@if (mentions()?.length > 0) {
    <mulo-centered-block-layout class="media">
        <h2 class="portal-section-title">
            {{ 'esploro.research.conf.research.portal.label.prefix.orgTree.unitHomepage.mediaMentions' | translate }}
        </h2>
        <div class="media-content">
            <swiper
                [autoplay]="false"
                [navigation]="{}"
                [pagination]="{ clickable: true }"
                [slidesPerView]="media.is('gt-sm') ? 3 : 1"
                [spaceBetween]="55"
            >
                @for (mm of mentions(); track mm.entityId) {
                    <ng-template swiperSlide>
                        <exl-citation-brief
                            [titleClickable]="mm.links?.length > 0"
                            [titleUrl]="mm.links[0]?.linkURL"
                            [type]="mm.type"
                            [title]="mm.title"
                            [titleHeaderLevel]="3"
                        >
                            <p class="mention-byline">{{ getByline(mm) }}</p>
                            <p class="mention-date">{{ mm.dateMedia }}</p>
                            @if (mm.links?.[0]?.linkRights; as linkRightsKey) {
                                <p
                                    class="mention-rights"
                                    [translate]="'esploro.accessRights.links.' + linkRightsKey"
                                ></p>
                            }
                        </exl-citation-brief>
                    </ng-template>
                }
            </swiper>
        </div>
    </mulo-centered-block-layout>
}
